const BuildBoxCart = document.querySelector('cart-drawer');
const BuildCartItems = document.querySelector('div#CartDrawer').querySelector('cart-drawer-items');
document.addEventListener('change', function(event) {
    if (!event.target.matches('ul.bb-pro-filter-row input[type="checkbox"]')) return;
    document.querySelector('ul.build-box-products-row').classList.add('data-load');
    let input = event.target,
      label = document.querySelector('[for="'+input.getAttribute('id')+'"]').textContent;
    console.log(label);
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function() {
      updataBuildBoxData(this,input.checked,input.value);
      setTimeout(()=>{
        clickEvents();
      },100);
    }
    xhttp.open("GET", '/collections/all/'+input.value+'?section_id=build-box-filter-data');
    xhttp.send();
});

// filter open 
let windowWidth = window.matchMedia("(max-width: 750px)")
if(document.querySelector('.bb-pro-filter span.filter__select-option')){
  document.querySelector('.bb-pro-filter span.filter__select-option').onclick = function(){
    if(document.querySelector('.build-box-products-row-main.mobile-filter-update') && windowWidth.matches) {
      document.querySelector('.build-box-products-row-main.mobile-filter-update .build-mob-filter-values').style.left = '0px';
    }else{
      $('ul.bb-pro-filter-row').slideToggle();
    }
  }
}

if(document.querySelector('.build-box-products-row-main.mobile-filter-update button.back-to-build-fil')){
  document.querySelector('.build-box-products-row-main.mobile-filter-update button.back-to-build-fil').onclick = function(){
      document.querySelector('.build-box-products-row-main.mobile-filter-update .build-mob-filter-values').style.left = '100%';
  }
}
  
// on mobile
if(document.querySelector('.build-box-products-data span.filter-icon.hide-deks')){
  document.querySelector('.build-box-products-data span.filter-icon.hide-deks').onclick = function(){
      document.querySelector('.bb-pro-filter-main').style.right = '0px';
      document.querySelector('body').classList.add('ctm-fill-open');
  }
}

// filter close
$(document).mouseup(function(e) {
  var container = $('.bb-pro-filter');
  if (windowWidth.matches) { // If media query matches
    container = $('.bb-pro-filter-main');
    if (!container.is(e.target) && container.has(e.target).length === 0){
      document.querySelector('.bb-pro-filter-main').style.right = '-100%';
      document.querySelector('body').classList.remove('ctm-fill-open');
    }
  }
})
if(document.querySelector('.bb-pro-filter-main svg.icon.icon-close')){
  document.querySelector('.bb-pro-filter-main svg.icon.icon-close').onclick = function(){
      document.querySelector('.bb-pro-filter-main').style.right = '-100%';
      document.querySelector('body').classList.remove('ctm-fill-open');
  }
}


function updataBuildBoxData(ajax,check,filterValue) {
    let parser = new DOMParser(),
    oldData = document.querySelector('ul.build-box-products-row').innerHTML,
    parsedDocument = parser.parseFromString(ajax.response, "text/html"),
    filterData = parsedDocument.querySelector('#get-build-data');
    if(check){
      filterData.querySelectorAll('.build-box-product-card').forEach((ele)=>{
        ele.setAttribute('data-tag',filterValue);
      });
      document.querySelector('ul.build-box-products-row').innerHTML = filterData.innerHTML+oldData;
    }else{        
      filterData.querySelectorAll('.build-box-product-card').forEach((ele)=>{
        let handle = ele.dataset.handle;
        if(document.querySelector('.build-box-product-card[data-handle="'+handle+'"][data-tag="'+filterValue+'"]')){
          console.log(document.querySelector('.build-box-product-card[data-handle="'+handle+'"][data-tag="'+filterValue+'"]'));
          document.querySelector('.build-box-product-card[data-handle="'+handle+'"][data-tag="'+filterValue+'"]').remove();
        }
      });
      let oldData = document.querySelector('ul.build-box-products-row').innerHTML;
      document.querySelector('ul.build-box-products-row').innerHTML = oldData;
    }
    document.querySelector('ul.build-box-products-row').classList.remove('data-load');
    if($(document).find('.build-box-product-card').length){
      var articleArray =  [];
      var duplicateHandles = [];
      $(document).find('.build-box-product-card').removeClass('hidden');
      $(document).find('.build-box-product-card').each(function(item){
        var getHandle = $(this).data('handle');
        if (articleArray.indexOf(getHandle) !== -1) {
          duplicateHandles.push(getHandle);
        } else {
          articleArray.push(getHandle);
        }
      });
      $.each(duplicateHandles, function(index, value) {
        $(document).find('.build-box-product-card[data-handle="'+value+'"]').each(function(index){
          if(index !== 0){
            $(this).addClass('hidden');
          }
        });
      });
    }
}

// build box click events
function clickEvents() {
  if(document.querySelector('#bbp-view-cart')){
    document.querySelector('#bbp-view-cart').addEventListener('click',function(){
      viewCart();
    });
  }
  if(document.querySelectorAll('.bbp-cart-item-info quantity-input.quantity input.quantity__input').length){
    document.querySelectorAll('.bbp-cart-item-info quantity-input.quantity input.quantity__input').forEach(function (ele) {
      ele.addEventListener('change',function(){
        document.querySelector('div#build-box-product-cart-main').classList.add('data-load');
        let val = ele.value;
        let line = ele.dataset.index;
        buildUpdateQuantity(line,val);
      })
    });
  }
  if(document.querySelectorAll('.bbp-cart-item-remove').length){
    document.querySelectorAll('.bbp-cart-item-remove').forEach(function (ele) {
      ele.addEventListener('click',function(){
        document.querySelector('div#build-box-product-cart-main').classList.add('data-load');
        let key = ele.closest('.bbp-cart-item-row').dataset.key;
        let line = ele.dataset.index;
        removeItem(key,line);
      })
    });
  }
  if(document.querySelector('span.bb-cart-clear')){
    document.querySelector('span.bb-cart-clear').addEventListener('click',function(){
      document.querySelector('div#build-box-product-cart-main').classList.add('data-load');
      removeBuildBox(this);
    })
  }
  if(document.querySelector('cart-remove-button#CartDrawer-Remove-0')){
    document.querySelector('cart-remove-button#CartDrawer-Remove-0').addEventListener('click',function(){
      if(document.querySelector('div#build-box-product-cart-main')){
        document.querySelector('div#build-box-product-cart-main').classList.add('data-load');
      }
      removeBuildBox(this);
    })
  }
  if(document.querySelector('a.choose-packge')){
    document.querySelector('a.choose-packge').addEventListener('click',function(e){
      e.preventDefault();
      shipPopup();
    });
  }
  
  if(document.querySelector('.pop-up-card svg.icon-close')){
    document.querySelector('.pop-up-card svg.icon-close').addEventListener('click',function(e){
      e.preventDefault();
      shipPopupClose();
    })
  }
  if(document.querySelector('.pop-up-card button.save-btn')){
    document.querySelector('.pop-up-card button.save-btn').addEventListener('click',function(e){
      e.preventDefault();
      shipPopupClose();
      updatePacking(true);
    })
  }
  if(document.querySelector('.bb-product-info-popup svg.feather.feather-x')){
    document.querySelector('.bb-product-info-popup svg.feather.feather-x').addEventListener('click',function(){
      document.querySelector('.bb-product-info-popup-wrapper').style.display = 'none';
    })
  }
  if(document.querySelectorAll('svg.bb-pro-info-icon').length){
    document.querySelectorAll('svg.bb-pro-info-icon').forEach((ele)=>{
      ele.addEventListener('click',function(){
        let pTitle = this.closest('.bb-product-card').querySelector('.bb-pro-info h3').textContent,
            pDes = this.closest('.bb-product-card').querySelector('.product-info-data').innerHTML,
            pImg = this.closest('.bb-product-card').querySelector('.bb-product-card-img img').src;
            infoPopup(pTitle,pDes,pImg);
      })
    })
  }
}
clickEvents();

// custom popup
function shipPopup() {
  document.querySelector('.custom-section-popup').style.display = 'block';
  setTimeout(()=>{
    document.body.style.overflow = 'hidden';
    document.querySelector('div#shopify-section-custom-pop-up').classList.add('its-show');
  },100);
}

// custom popup close
function shipPopupClose() {
  document.querySelector('div#shopify-section-custom-pop-up').classList.remove('its-show');
  setTimeout(()=>{
    document.querySelector('.custom-section-popup').style.display = 'none';
    document.body.style.overflow = 'unset';
  },100);
}

// info Popup
function infoPopup(pTitle,pDes,pImg) {
  document.querySelector('.bb-product-info-pop-main h3').textContent = pTitle;
  document.querySelector('.bb-product-info-pop-main .bb-product-info-des').innerHTML = pDes;
  document.querySelector('.bb-product-info-img img').src = pImg;
  document.querySelector('.bb-product-info-popup-wrapper').style.display = 'block';
}
// update build box cart
function updateBuildBox(data) {
  if(document.querySelector('div#build-box-product-cart-main')){
    let updatedData = data.sections['build-box-cart-data'];
    updatedData = new DOMParser().parseFromString(updatedData, 'text/html').querySelector('#shopify-section-build-box-cart-data').innerHTML;
    document.querySelector('div#build-box-product-cart-main').innerHTML = updatedData;
  }
  setTimeout(function(){
    clickEvents();
    if(document.querySelector('div#build-box-product-cart-main')){
      document.querySelector('div#build-box-product-cart-main').classList.remove('data-load');
    }
  },500);
  removePack();
}

// open cart 
function viewCart() {
  BuildBoxCart.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  BuildBoxCart.open();
}

// update item quantity 
function buildUpdateQuantity(itemIndex,itemQty) {
  console.log(itemIndex,itemQty);
  BuildCartItems.updateQuantity(itemIndex, itemQty);
}

// remove item 
function removeItem(itemKey,itemIndex) {
  BuildCartItems.updateQuantity(itemIndex, 0);
}

async function getCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return null; // or handle the error as needed
  }
}

// remove all items
async function removeBuildBox(ele) {
  if(ele.dataset.index == 0){
    ele.closest('tr.cart-item').querySelector('.loading__spinner').classList.remove('hidden');
  }
  let currentCart = await getCart();
  let obj = currentCart.items;
  let updates = {};
  let secData = [
    "cart-drawer",
    "cart-icon-bubble",
    "build-box-cart-data"
  ]
  
  for (let i = 0; i < obj.length; i++) {
    let proObj = obj[i]['properties']['_buildbox'];
    if(proObj === 'true'){
      let Id = obj[i].id;
      updates[Id] = 0;
    }
  }

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      updates,
      sections: secData,
      sections_url: window.location.pathname
    })
  })
  .then(response => {
    return response.json();
  }).then(response => { 
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', response.item_count === 0);
    if(document.body.classList.contains('temp_page-build-box')){
      updateBuildBox(response);
    }
    updatePacking(false);
    BuildBoxCart.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = BuildBoxCart.getSectionInnerHTML(response.sections[section.id], section.selector);
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// update packaging qoption
function updatePacking(check){
  let packVal = document.querySelector('.pop-up-card .pop-select').value;
  let packRecVal = document.querySelector('.pop-up-card textarea.pop-input').value;
  let attriButes =  {
    attributes: {
      'Pack my Build box beef in':packVal
    }
  };
  console.log(packRecVal+'  444');
  if(packRecVal != ''){
    attriButes.attributes['Requests for build box'] = packRecVal;
  }else{
    attriButes.attributes['Requests for build box'] = '';
  }
  if(check){}else{
    attriButes.attributes['Requests for build box'] = '';
    attriButes.attributes['Pack my Build box beef in'] = '';
  }
  attriButes.sections = BuildBoxCart.getSectionsToRender().map((section) => section.id)
  attriButes.sections_url = window.location.pathname;
  fetch('/cart/update.js', {
    method: "POST",
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
    },
    body: JSON.stringify(attriButes)
  }).then((data)=> data.json()).then((data) =>{
    BuildBoxCart.renderContents(data,true)
    if(data.item_count){
      document.querySelector('.pop-up-main svg.icon-close').dispatchEvent(new Event('click'));
    }
  })
}

// remove packoption
async function removePack(){
  let currentCart = await getCart();
  let obj = currentCart.items;  
  let noItem = true;
  for (let i = 0; i < obj.length; i++) {
    let proObj = obj[i]['properties']['_buildbox'];
    if(proObj === 'true'){
      noItem = false;
      break;
    }
  }
  if(noItem){
    console.log('4848')
    fetch('/cart/update.js', {
      method: "POST",
      headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;'
      },
      body: JSON.stringify({
          attributes: {
            'Pack my beef in':'',
            'Requests for build box':''
          }
      })
    })
  }
}

// view your box
if(document.querySelector('.go-to-box')){
  document.querySelector('.go-to-box').addEventListener('click',function(){
      let ofTop = document.querySelector('div#build-box-product-cart-main').offsetTop;
      window.scrollTo(0,ofTop);
  });
  window.addEventListener('scroll',function(){
    let ofTop = document.querySelector('div#build-box-product-cart-main').offsetTop,
      ofHeight = document.querySelector('div#build-box-product-cart-main').offsetHeight,
      tOff = ofTop+ofHeight+100;
    if(pageYOffset > tOff){
      document.querySelector('.go-to-box').style.display = 'block';
    }else{
      document.querySelector('.go-to-box').style.display = 'none';
    }
  })
}

// variants selector
// document.querySelectorAll('.bb-pro-variants-main input[type=radio]').forEach((ele)=>{
//     ele.onchange = function (){
//         this.closest('li.build-box-product-card').querySelector('form.form[action="/cart/add"] input.product-variant-id').value = this.value;
//     }
// });

$(document).on('change','.bb-pro-variants-main input[type=radio]',function () {
  $(this).parents('li.build-box-product-card').find('form.form[action="/cart/add"] input.product-variant-id').val($(this).val());
  let tbvest = $(this).attr('id') ;
  let product_weight = $(this).siblings(`[for=${tbvest}]`).text();
  let product_price = $(this).attr('data-price');
  $(this).parents('.bb-product-info-main').find('.bb-pro-weight').text(product_weight)
  $(this).parents('.bb-product-info-main').find('.custom-tb-price-varient').text(moneyFormate(product_price));
})


function checkPacking() {
  if(document.querySelectorAll('.bbp-cart-item-row').length){
    console.log('test1');
    updatePacking(true);
  }else{
    console.log('test2');
    updatePacking(false);
  }
}
window.addEventListener('load',function name(params) {
  if(document.querySelector('.temp_page-build-box')){
    checkPacking();
  }
})
